
export interface NicePayCallbackRequest {
  /** 결제 금액 */
  amount?: string;
  /** 빌링키 */
  billingKey?: string;
  /** 주문 ID */
  orderId: string;
  /** 결과 코드 */
  resultCode: string;
  /** 결과 메시지 */
  resultMsg: string;
  /** 거래 ID */
  tid: string;
}
